export default {"src":"/_next/static/media/plus-orange.faf22361.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};